module.exports = __webpack_public_path__ + "static/img/storage1.7d10df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storage1.png
// module id = fX6z
// module chunks = 2